import './newsletter-cta.css'

export default function NewsletterCTA() {
  return (
    <section className='newsletter-cta'>
      <div className='newsletter-cta__content'>
        <p className='newsletter-cta__text'>
          Suscríbete si quieres estar informada/informado de todas nuestras novedades y eventos:
        </p>
        <a 
          href='https://4bd89425.sibforms.com/serve/MUIFAMzQehmPCUlLQHdAJXCJ0Zxb4qQQHN6Xxj3-3v_Y0FbQOepZbh8gI7xM8gsYmkF__YkSrNsCQBXaZwnPuxh6unWMl2MMemeVmq7V72RV3iLvTPJn7Caz2w_S5z5Fck9b6M1Vst0rS5VpMOC_rhjqdmu7EPsfu1HVJaDCYt5sQA97jXJ3K7gXhqTjH8pgkXXGvMIlX1N88CS-'
          className='newsletter-cta__button'
          target='_blank'
          rel='noopener noreferrer'
        >
          Recibir novedades→
        </a>
      </div>
    </section>
  )
}
